import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomAirVolumePerAreaInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomAirVolumePerAreaInput = React.memo(
  ({ className, hideLabel }: RoomAirVolumePerAreaInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name="room.airVolumePerArea"
        className={classNames("room-form__air-volume-per-area", className)}
        label={t("Room.airVolumePerArea")}
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 2 }}
        step={0.1}
        data-testid="room__air-volume-per-area__input"
      >
        {!hideLabel && <NumberInput.Label />}
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
